import { render, staticRenderFns } from "./WorkspaceNewRow.vue?vue&type=template&id=5faf79b4&"
import script from "./WorkspaceNewRow.vue?vue&type=script&lang=js&"
export * from "./WorkspaceNewRow.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceNewRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports